import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { auth0OnboardingApiRef, Auth0OnboardingClient } from './api';

/**
 * Auth0 Onboarding frontend plugin
 *
 * Provides components for viewing Auth0 application credentials
 * stored in Azure Key Vault.
 */
export const auth0OnboardingPlugin = createPlugin({
  id: 'auth0-onboarding',
  apis: [
    createApiFactory({
      api: auth0OnboardingApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new Auth0OnboardingClient({ discoveryApi, fetchApi }),
    }),
  ],
});
